<template>
  <main class="flex-item" v-if="renewal.rnw01p !== undefined && renewal.hsm03p !== undefined && renewal.rnw02p !== undefined">
    <div class="card">
      <header class="card-header page-title">
        <p class="card-header-title is-size-4"><span class="material-icons is-size-4">description</span>更新内容入力</p>
      </header>

      <!-- 目的の所在地 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">home</span>目的の所在地</div>
          </header>
          <div class="card-content">
            <div class="columns ml-5">
              <div class="column py-1">
                <p>住所</p>
              </div>
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka1" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1" />
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka2" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1">
                <p>住所（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka3" />
              </div>
            </div>
            <div class="columns ml-5">
              <div class="column py-1" />
              <div class="column is-flex-grow-2 has-text-weight-bold py-1">
                <HyphenParagraph :text="mainInsured?.tf_rhhka4" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 申込人（契約者）情報 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">person</span>申込人（契約者）情報</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <p class="mb-0">氏名</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekykj" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">氏名（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekykn" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">郵便番号</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekyyn" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">住所</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya1" />
              </div>
            </div>
            <div class="columns">
              <div class="column" />
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya2" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">住所（フリガナ）</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya3" />
              </div>
            </div>
            <div class="columns">
              <div class="column" />
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekya4" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">携帯電話番号</p>
              </div>
              <div class="column is-7">
                <input type="text" class="input is-small mb-0" v-model="form.rnw01p.tfRekyt2" @input="validTelNo" />
                <ErrorField :error="f$.rnw01p.tfRekyt2.$errors" />
              </div>
            </div>
            <div class="columns">
              <div class="column is-4">
                <p class="mb-0">その他電話番号</p>
              </div>
              <div class="column is-7">
                <input type="text" class="input is-small mb-0" v-model="form.rnw01p.tfRekytl" @input="validTelNo" />
                <ErrorField :error="f$.rnw01p.tfRekytl.$errors" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">メールアドレス</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="renewal.rnw01p.tf_rekyma" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 被保険者 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">groups</span>被保険者</div>
          </header>
          <div class="card-content">
            <!-- 目的の所有者の代表者(undefindになることはないが一応) -->
            <div class="card block" v-if="mainInsured !== undefined">
              <input
                type="checkbox"
                id="owner-same-contractor"
                class="check-type-2 is-cb-medium"
                :true-value="constants.HAIIIE.HAI"
                :false-value="constants.HAIIIE.IIE"
                v-model="mainInsured.tf_rhkysm"
                disabled
              />
              <header class="card-header">
                <div class="is-size-4 card-header-title">
                  <span class="material-icons accent-color">account_circle</span>目的の所有者の代表者
                  <label for="owner-same-contractor" class="is-size-6 ml-6 has-text-weight-bold has-text-dark">申込人と同じ</label>
                </div>
              </header>
              <div class="card-content">
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">氏名</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhksj" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">氏名（フリガナ）</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhksk" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">生年月日</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhkbt" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">性別</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="getGenderText(mainInsured.tf_rhhksx)" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">携帯電話番号</p>
                  </div>
                  <div class="column is-7">
                    <input type="text" class="input is-small mb-0" v-model="form.rnw02p.tfRhhkt2" @input="validInsuredTelNo" />
                    <ErrorField :error="f$.rnw02p.tfRhhkt2.$errors" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column is-4">
                    <p class="mb-0">その他電話番号</p>
                  </div>
                  <div class="column is-7">
                    <input type="text" class="input is-small mb-0" v-model="form.rnw02p.tfRhhktl" @input="validInsuredTelNo" />
                    <ErrorField :error="f$.rnw02p.tfRhhktl.$errors" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <p class="mb-0">メールアドレス</p>
                  </div>
                  <div class="column is-flex-grow-2">
                    <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="mainInsured.tf_rhhkma" />
                  </div>
                </div>
              </div>
            </div>

            <!-- 被保険者 -->
            <template v-if="subInsureds !== undefined">
              <SubInsured
                v-for="(v, i) in subInsureds"
                :key="i"
                :tf_khhkno="v.tf_rhhkno"
                :tf_khhksj="v.tf_rhhksj"
                :tf_khhksk="v.tf_rhhksk"
                :tf_khhkbt="v.tf_rhhkbt"
                :tf_khhksx="v.tf_rhhksx"
              />
            </template>
          </div>
        </div>
      </div>

      <!-- 申込内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">article</span>申込内容</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column">
                <p class="mb-0">申込日</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="nowDate" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">保険期間</p>
              </div>
              <div class="column is-flex-grow-2">
                <HyphenParagraph :generalClass="'mb-0 has-text-weight-bold'" :text="`${renewal.rnw01p.tf_reskdt} ~ ${renewal.rnw01p.tf_remkdt}`" />
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">契約区分</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">新規</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">建物</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getKozoText(mainInsured?.tf_rhkozo ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">物件</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getSyoyuText(mainInsured?.tf_rhsykb ?? "") }}</p>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <p class="mb-0">目的</p>
              </div>
              <div class="column is-flex-grow-2">
                <p class="mb-0 has-text-weight-bold">{{ getYoutoText(mainInsured?.tf_rhytkb ?? "") }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 補償内容 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">savings</span>補償内容</div>
          </header>
          <div class="card-content">
            <div class="columns">
              <div class="column is-7-tablet is-5-desktop is-4-widescreen">
                <div class="field">
                  <label class="label">合計保険料</label>
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="form.rnw01p.tfRehkpl">
                        <option v-for="f in feeOptions" :key="f.plan" :value="f.plan">{{ f.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <ErrorField :error="f$.rnw01p.tfRehkpl.$errors" />
              </div>
            </div>
            <div class="columns is-block">
              <div class="column is-12 pb-0">
                <label class="label">家財保険</label>
                <p class="text-info">※修理費用拡張担保特約および契約手続きに関する特約を含みます</p>
              </div>
              <div class="column is-7-tablet is-5-desktop is-4-widescreen">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="form.rnw01p.tfRehkpl" disabled>
                        <option v-for="h in houseOptions" :key="h.plan" :value="h.plan">{{ h.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="columns is-block">
              <div class="column is-12 pb-0">
                <label class="label">賠償責任保険</label>
                <p class="text-info">※借家人賠償責任保険、個人賠償責任保険は合計で1,000万円が限度となります。</p>
              </div>
              <div class="column is-7-tablet is-5-desktop is-4-widescreen">
                <div class="field">
                  <div class="control">
                    <div class="select is-fullwidth">
                      <select v-model="form.rnw01p.tfRehkpl" disabled>
                        <option v-for="l in liabilityOptions" :key="l.plan" :value="l.plan">{{ l.text }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- お支払い方法 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header">
            <div class="is-size-4 card-header-title"><span class="material-icons accent-color">update</span>お支払い方法</div>
          </header>
          <div class="card-content">
            <div class="columns ml-2">
              <div class="field">
                <div class="control">
                  <input
                    type="radio"
                    id="payment-convenience"
                    class="radio-type-2"
                    v-model="form.rnw01p.tfRehkhh"
                    :value="constants.HARAIKOMI_HOUHOU.CONVENI"
                    name="payment"
                    checked
                  />
                  <label for="payment-convenience">コンビニ決済</label>
                </div>
              </div>
            </div>
            <div class="columns ml-2 py-3">
              <img class="store-logo mr-2" src="images/logo-seven.svg" />
              <img class="store-logo mr-2" src="images/logo-familymart.svg" />
              <img class="store-logo" src="images/logo-lawson.svg" />
            </div>
            <div class="columns ml-2">
              <p>コンビニ店頭にてお支払いいただけます。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- その他保険 -->
      <div class="card-content">
        <div class="card">
          <header class="card-header card-title">
            <p class="card-header-title is-size-4"><span class="material-icons accent-color">more</span>その他保険</p>
          </header>
          <div class="card-content other-insurance-info">
            <div class="other-insured-item">
              <input
                type="checkbox"
                id="other-insured-join"
                v-model="form.rnw01p.tfRethum"
                :true-value="constants.UMU.ARI"
                :false-value="constants.UMU.NASI"
                class="check-type-1"
                @click="validOtherInsurance"
              />
              <label for="other-insured-join" class="has-text-weight-bold has-text-dark">他社の保険に加入している</label>
              <div class="other-insured-join-info">
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <div class="field">
                      <div class="control">
                        <input
                          type="checkbox"
                          v-model="thRethsrArr"
                          :value="constants.HOKEN_SYURUI.HOUSE"
                          id="other-insured-household"
                          class="check-type-1"
                        />
                        <label for="other-insured-household" class="has-text-dark mr-6">家財保険</label>
                        <input
                          type="checkbox"
                          v-model="thRethsrArr"
                          :value="constants.HOKEN_SYURUI.LIABILITY"
                          id="other-insured-liability"
                          class="check-type-1"
                        />
                        <label for="other-insured-liability" class="has-text-dark">個人賠償責任保険</label>
                      </div>
                    </div>
                  </div>
                  <div class="column is-12">
                    <label class="label">会社名</label>
                    <div class="field">
                      <div class="control">
                        <input class="input" type="text" @change="validOtherInsurance" v-model="form.rnw01p.tfRethcm" />
                      </div>
                    </div>
                    <ErrorField :error="f$.rnw01p.tfRethcm.$errors" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="card-footer">
        <div class="card-footer-item">
          <span class="mr-4">
            <button class="card-footer-item button is-primary is-normal is-medium" @click="submit">更新内容の確認へ進む</button>
          </span>
          <span>
            <router-link :to="{ name: 'Top' }" class="card-footer-item button is-normal is-medium">キャンセル</router-link>
          </span>
        </div>
      </footer>
    </div>
  </main>
</template>

<script lang="ts">
import { getRenewal, renewalResponse, rnw02p, insuranceFeeOptions } from "@/api/renewal";
import { renewalSubmitRequest } from "@/api/renewalSubmit";
import router from "@/router";
import axios from "axios";
import { commaSplit } from "common/src/utils/number";
import { getGenderText, getHaraikomiText } from "common/src/utils/codes";
import HyphenParagraph from "common/src/components/HyphenParagraph.vue";
import constants from "common/src/constants";
import { defineComponent, reactive, Ref, ref, UnwrapRef } from "vue";
import SubInsured from "common/src/components/SubInsured.vue";
import useVuelidate from "@vuelidate/core";
import { SCR130FormValidateRule } from "@/forms/scr130";
import ErrorField from "common/src/components/ErrorField.vue";
import { scrollToError } from "common/src/utils/screen";
import { MutationTypes, useStore } from "@/store";
import { getSyoyuText, getYoutoText, getKozoText } from "common/src/utils/codes";

export default defineComponent({
  components: {
    HyphenParagraph,
    SubInsured,
    ErrorField,
  },
  setup() {
    const renewal: UnwrapRef<renewalResponse> = reactive({
      rnw01p: undefined,
      hsm03p: undefined,
      rnw02p: undefined,
    });
    const mainInsured: Ref<rnw02p | undefined> = ref(undefined);
    const subInsureds: Ref<rnw02p[] | undefined> = ref(undefined);

    const feeOptions: Ref<insuranceFeeOptions[]> = ref([]);
    const houseOptions: Ref<insuranceFeeOptions[]> = ref([]);
    const liabilityOptions: Ref<insuranceFeeOptions[]> = ref([]);
    const nowDate = `${new Date().getFullYear()}/${`00${new Date().getMonth() + 1}`.slice(-2)}/${`00${new Date().getDate()}`.slice(-2)}`;

    const form: UnwrapRef<renewalSubmitRequest> = reactive({
      rnw01p: {
        tfRekytl: "",
        tfRekyt2: "",
        tfRehscd: "",
        tfRehkpl: "",
        tfRegkhk: 0,
        tfRehkhh: "",
        tfReconv: "",
        tfRethum: "",
        tfRethcm: "",
        tfRethsr: "",
        tfRehkdt: 0,
      },
      rnw02p: {
        tfRhhktl: "",
        tfRhhkt2: "",
        tfRhhkdt: 0,
      },
      security: {
        tfHnuuid: "",
      },
    });

    // 他保険種類管理配列
    const thRethsrArr: Ref<string[]> = ref([]);

    const store = useStore();

    getRenewal()
      .then((res) => {
        if (res.data.rnw01p?.tf_rekzis === constants.KEIZOKU_ISHI.ARI) {
          router.push({ name: "404" });
          return;
        }

        renewal.rnw01p = res.data.rnw01p;
        renewal.hsm03p = res.data.hsm03p;
        renewal.rnw02p = res.data.rnw02p;

        mainInsured.value = res.data.rnw02p?.find((i) => i.tf_rhhkno === constants.MAIN_INSURED_NUMBER);
        subInsureds.value = res.data.rnw02p
          ?.filter((i) => i.tf_rhhkno !== constants.MAIN_INSURED_NUMBER)
          .sort((a, b) => Number.parseInt(a.tf_rhhkno) - Number.parseInt(b.tf_rhhkno));

        // 更新契約手続きAPI呼び出し用Formに値をセット
        // ストアにFormの値がセットされている場合、ストアの値をセット
        const movedFromConfOrPay = store.state.renewal?.rnw01p.tfRekytl !== undefined;
        form.rnw01p.tfRekytl = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRekytl : res.data.rnw01p?.tf_rekytl;
        form.rnw01p.tfRekyt2 = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRekyt2 : res.data.rnw01p?.tf_rekyt2;
        form.rnw01p.tfRehscd = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRehscd : res.data.rnw01p?.tf_rehscd;
        form.rnw01p.tfRehkpl = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRehkpl : res.data.rnw01p?.tf_rehkpl;
        form.rnw01p.tfRegkhk = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRegkhk : res.data.rnw01p?.tf_regkhk;
        form.rnw01p.tfRehkhh = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRehkhh : constants.HARAIKOMI_HOUHOU.CONVENI;
        form.rnw01p.tfRehkdt = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRehkdt : res.data.rnw01p?.tf_rehkdt;
        form.rnw01p.tfRethum = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRethum : constants.UMU.NASI;
        form.rnw01p.tfRethcm = movedFromConfOrPay ? store.state.renewal?.rnw01p?.tfRethcm : "";
        if (movedFromConfOrPay && store.state.renewal?.rnw01p.tfRethsr !== undefined && store.state.renewal?.rnw01p.tfRethsr.length > 0) {
          thRethsrArr.value.push(...(store.state.renewal?.rnw01p.tfRethsr?.split("/") ?? []));
        }
        form.rnw02p.tfRhhktl = movedFromConfOrPay ? store.state.renewal?.rnw02p?.tfRhhktl : mainInsured.value?.tf_rhhktl;
        form.rnw02p.tfRhhkt2 = movedFromConfOrPay ? store.state.renewal?.rnw02p?.tfRhhkt2 : mainInsured.value?.tf_rhhkt2;
        form.rnw02p.tfRhhkdt = movedFromConfOrPay ? store.state.renewal?.rnw02p?.tfRhhkdt : mainInsured.value?.tf_rhhkdt;
        form.security.tfHnuuid = store.state.renewal?.security?.tfHnuuid;

        if (renewal.rnw01p && form.security.tfHnuuid && store.state.mail) {
          renewal.rnw01p.tf_rekyma = store.state.mail;
        }

        // プラン部分のoption構築
        res.data.hsm03p?.forEach((p) => {
          feeOptions.value.push({ plan: p.tf_hrplan, text: `${commaSplit(p.tf_hrhrgk)}円` });
          houseOptions.value.push({
            plan: p.tf_hrplan,
            text: `保険金額：${commaSplit(p.tf_hrhkkg)}万円 | 保険料：${commaSplit(p.tf_hrhrhk)}円`,
          });
          liabilityOptions.value.push({
            plan: p.tf_hrplan,
            text: `保険金額：${commaSplit(p.tf_hrhtkg)}万円 | 保険料：${commaSplit(p.tf_hrhthk)}円`,
          });
        });
      })
      .catch((err) => {
        if (axios.isAxiosError(err) && err.response?.status === 404) {
          router.push({ name: "404" });
        }
      });

    // フィールドエラーを外部からセットする変数
    const $externalResults = ref({
      rnw01p: {},
      rnw02p: {},
    });
    // フィールドエラー設定初期化
    const f$ = useVuelidate(SCR130FormValidateRule, form, {
      $autoDirty: true,
      $externalResults,
    });

    // 電話番号入力時の検証処理
    const validTelNo = () => {
      $externalResults.value.rnw01p = {
        ...$externalResults.value.rnw01p,
        ...{ tfRekytl: [], tfRekyt2: [] },
      };
      f$.value.rnw01p.tfRekytl.$touch();
      f$.value.rnw01p.tfRekyt2.$touch();
      if (form.rnw01p.tfRekytl === "" && form.rnw01p.tfRekyt2 === "") {
        $externalResults.value.rnw01p = {
          ...$externalResults.value.rnw01p,
          ...{ tfRekytl: ["いずれかの電話番号を入力してください"], tfRekyt2: ["いずれかの電話番号を入力してください"] },
        };
      }
    };

    // 被保険者電話番号入力時の検証処理
    const validInsuredTelNo = () => {
      $externalResults.value.rnw02p = {
        ...$externalResults.value.rnw02p,
        ...{ tfRhhktl: [], tfRhhkt2: [] },
      };
      f$.value.rnw02p.tfRhhktl.$touch();
      f$.value.rnw02p.tfRhhkt2.$touch();
      if (form.rnw02p.tfRhhktl === "" && form.rnw02p.tfRhhkt2 === "") {
        $externalResults.value.rnw02p = {
          ...$externalResults.value.rnw02p,
          ...{ tfRhhktl: ["いずれかの電話番号を入力してください"], tfRhhkt2: ["いずれかの電話番号を入力してください"] },
        };
      }
    };

    // 他保険会社名に関する検証処理
    const validOtherInsurance = () => {
      $externalResults.value.rnw01p = {
        ...$externalResults.value.rnw01p,
        ...{ tfRethcm: [] },
      };
      f$.value.rnw01p.tfRethcm.$touch();
      if (form.rnw01p.tfRethum === constants.UMU.ARI) {
        if (form.rnw01p.tfRethcm === "") {
          $externalResults.value.rnw01p = {
            ...$externalResults.value.rnw01p,
            ...{ tfRethcm: ["会社名を入力してください"] },
          };
        }

        if ((form.rnw01p.tfRethcm?.length ?? 0) > 120) {
          $externalResults.value.rnw01p = {
            ...$externalResults.value.rnw01p,
            ...{ tfRethcm: ["会社名は120文字以内で入力してください"] },
          };
        }
      }
    };

    // 検証後、更新契約手続きFormをstoreに格納
    const submit = async () => {
      f$.value.$touch();
      validInsuredTelNo();
      validTelNo();
      validOtherInsurance();
      if (f$.value.$invalid) {
        scrollToError();
        return;
      }

      // 契約者と同じの場合は、被保険者へ契約者情報をセット
      if (mainInsured.value?.tf_rhkysm === constants.HAIIIE.HAI) {
        form.rnw02p.tfRhhktl = form.rnw01p.tfRekytl;
        form.rnw02p.tfRhhkt2 = form.rnw01p.tfRekyt2;
      }

      // 他保険なしの場合は、他保険会社名・他保険種類をセットしない
      if (form.rnw01p.tfRethum === constants.UMU.NASI) {
        form.rnw01p.tfRethcm = "";
        form.rnw01p.tfRethsr = "";
      } else {
        form.rnw01p.tfRethsr = thRethsrArr.value.join("/");
      }

      // 保険プランから保険商品コードと保険料を事前に退避させておく
      form.rnw01p.tfRehscd = renewal.hsm03p?.find((p) => p.tf_hrplan === form.rnw01p.tfRehkpl)?.tf_hrshcd;
      form.rnw01p.tfRegkhk = renewal.hsm03p?.find((p) => p.tf_hrplan === form.rnw01p.tfRehkpl)?.tf_hrhrgk;

      store.commit(MutationTypes.SET_RENEWAL, form);

      router.push({ name: "RenewalConfirm" });
    };

    return {
      renewal,
      thRethsrArr,
      mainInsured,
      subInsureds,
      feeOptions,
      houseOptions,
      liabilityOptions,
      nowDate,
      constants,
      form,
      getGenderText,
      getHaraikomiText,
      SubInsured,
      commaSplit,
      validTelNo,
      validInsuredTelNo,
      validOtherInsurance,
      f$,
      submit,
      getSyoyuText,
      getYoutoText,
      getKozoText,
    };
  },
});
</script>
